<template>
  <div
    v-bind:style="{
      backgroundImage: 'url(' + backgroundImage + ')',
      backgroundSize: 'cover',
      height: '100%',
    }"
  >
    <div class="message-container" v-if="isLoading">
      <Loading size="xl" />
    </div>

    <div class="message-container" v-else-if="isError">
      <div class="d-flex h-50 flex-column justify-content-end">
        <div class="alert alert-danger p-4" role="alert">
          Lo sentimos, se produjo un error al cargar la información. Por favor,
          inténtelo de nuevo más tarde
        </div>
      </div>
      <div class="d-flex h-50 flex-column justify-content-end pb-5">
        <img width="120px" src="../../assets/logo-02.png" alt="Logo" />
      </div>
    </div>

    <div
      class="details-container container-sm container-md container-lg"
      v-else
    >
      <div class="row">
        <div
          class="col-12 text-center mt-1 mb-5"
          v-if="isViewedFromSmallScreen"
        >
          <div class="logo-container mb-4" v-if="srcLogo">
            <a :href="mainLogoLink">
              <FilledImage :src="srcLogo" />
            </a>
          </div>

          <div class="px-4">
            <h3 v-if="audio">ESCUCHAR ACÁ</h3>
            <AudioPlay
              :onPlay="onPlayEvent"
              id="audio-small-screens"
              v-if="audio"
              :src="audio"
              :autoplay="autoplay"
            />
            <div v-for="item in audios" :key="item.id">
              <h3>{{ item.title }}</h3>
              <AudioPlay
                :onPlay="onPlayEvent"
                id="audio-small-screens"
                :src="item.url"
                :autoplay="autoplay"
              />
            </div>
          </div>
          <div class="mb-1" v-if="whatsappNumber">
            <WhatsappContact :label="whatsappText" :phone="whatsappNumber" />
          </div>

          <SocialMedia :instagram="instagramUrl" />

          <div
            class="col-12 col-md-9 col-lg-7 text-lg mb-0 comment-container text-plantss-color"
            :style="{ color: textColor + '!important' }"
            v-if="isViewedFromSmallScreen"
            v-html="text"
          ></div>
        </div>

        <div class="col-12 mb-3" v-if="isViewedFromSmallScreen">
          <div class="px-0">
            <div class="mt-3 mb-3 text-center" v-if="mapUrl">
              <h3 :style="{ color: textColor + '!important' }" v-if="mapTitle">
                {{ mapTitle }}
              </h3>
              <LocationsMap :src="mapUrl" />
            </div>

            <LinksDownloadApps :showArrow="false" orientation="horizontal">
              <div
                class="download-text text-plantss-color text-center mb-4"
                :style="{ color: textColor + '!important' }"
              >
                Para mejorar tu experiencia<br />descarga gratis Plantsss
              </div>
              <div
                class="text-plantss-color text-center mb-4"
                :style="{
                  color: textColor + '!important',
                  fontSize: '1.2em',
                  fontWeight: 'bold',
                  transform: 'uppercase',
                  'text-transform': 'uppercase',
                }"
              >
                Toca acá según tu dispositivo
              </div>
            </LinksDownloadApps>
          </div>
        </div>

        <div class="col-lg-4">
          <div
            :style="{ color: textColor + '!important' }"
            class="video-section w-100 h-auto text-center mb-4"
            v-if="youtubeUrl"
          >
            <h3 className="w-100" v-if="youtubeTitle">
              {{ youtubeTitle }}
            </h3>
            <Youtube :url="youtubeUrl" />
          </div>
          <div class="screenshot-container">
            <Carousel :items="screenshots" />
          </div>
        </div>
        <div class="col-lg-8">
          <div class="row">
            <div
              class="col-12 col-md-8 offset-md-2 text-center mt-1 mb-5"
              v-if="!isViewedFromSmallScreen"
            >
              <div class="row">
                <div
                  class="col-md-4 offset-md-4 offset-3 mt-1 mb-5"
                  v-if="!isViewedFromSmallScreen"
                >
                  <div class="logo-container" v-if="srcLogo">
                    <a :href="mainLogoLink">
                      <FilledImage :src="srcLogo" />
                    </a>
                  </div>
                </div>
              </div>

              <h3 v-if="audio">ESCUCHAR ACÁ</h3>
              <AudioPlay
                :onPlay="onPlayEvent"
                id="audio-big-screens"
                v-if="audio"
                :src="audio"
                :autoplay="autoplay"
              />
              <div v-for="item in audios" :key="item.id">
                <h3>{{ item.title }}</h3>
                <AudioPlay
                  :onPlay="onPlayEvent"
                  id="audio-small-screens"
                  :src="item.url"
                  :autoplay="autoplay"
                />
              </div>

              <div class="mb-1" v-if="whatsappNumber">
                <WhatsappContact
                  :label="whatsappText"
                  :phone="whatsappNumber"
                />
              </div>
              <SocialMedia :instagram="instagramUrl" />
            </div>

            <div class="col-12">
              <div class="row">
                <div
                  class="col-12 mb-5 text-center"
                  v-if="mapUrl && !isViewedFromSmallScreen"
                >
                  <h3 v-if="mapTitle">{{ mapTitle }}</h3>
                  <LocationsMap :src="mapUrl" />
                </div>
              </div>

              <div class="row">
                <div
                  class="col-4 col-md-3 col-lg-2 offset-4 offset-md-0 mt-1 mb-5"
                >
                  <div class="logo-container" v-if="leftIcon">
                    <a :href="leftIconLink">
                      <FilledImage :src="leftIcon" />
                    </a>
                  </div>
                </div>

                <!-- este se oculta en mobile  -->
                <div
                  class="col-12 col-md-9 col-lg-7 text-lg mb-5 comment-container text-plantss-color"
                  :style="{ color: textColor + '!important' }"
                  v-if="!isViewedFromSmallScreen"
                  v-html="text"
                ></div>

                <div class="col-6 col-lg-3 offset-3 offset-lg-0 mb-5">
                  <div class="row">
                    <div
                      class="col-12 col-md-10 offset-md-2 offset-lg-0"
                      v-if="!isViewedFromSmallScreen"
                    >
                      <LinksDownloadApps orientation="vertical">
                        <div
                          class="download-text text-plantss-color text-center mb-4"
                          :style="{ color: textColor + '!important' }"
                        >
                          Para mejorar tu experiencia<br />descarga gratis
                          Plantsss
                        </div>
                        <div
                          class="text-plantss-color text-center mb-4"
                          :style="{
                            color: textColor + '!important',
                            fontSize: '1.2em',
                            fontWeight: 'bold',
                            transform: 'uppercase',
                            'text-transform': 'uppercase',
                          }"
                        >
                          Toca acá según tu dispositivo
                        </div>
                      </LinksDownloadApps>
                    </div>
                    <div
                      class="col-10 offset-1 col-md-10 offset-md-2 offset-lg-0 text-center mt-4"
                    >
                      <a :href="rightIconLink" v-if="rightIcon">
                        <FilledImage :src="rightIcon" />
                      </a>
                    </div>
                  </div>
                </div>

                <div class="col-12 mb-5">
                  <div
                    v-if="pdf"
                    class="d-flex justify-content-center align-items-center w-100"
                  >
                    <a
                      :href="pdf"
                      target="_blank"
                      class="text-dark text-lg font-weight-bold btn btn-link btn-outline-dark"
                    >
                      Download PDF
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CustomModal
      title="Validación de cliente"
      :modalId="'client-identifier'"
      v-if="!autoplay"
    >
      <ClientValidationForm
        :client="client"
        @validation-success="onValidationSuccess"
      />
    </CustomModal>
  </div>
</template>

<script>
import Axios from 'axios';
import APP_IDS from '../../constants';
import Carousel from '../Carousel.vue';
import CustomModal from '../CustomModal.vue';
import Loading from '../Loading.vue';
import LocationsMap from '../LocationsMap/LocationsMap.vue';
import SocialMedia from '../SocialMedia.vue';
import Youtube from '../Youtube.vue';
import AudioPlay from './AudioPlay.vue';
import ClientValidationForm from './ClientValidationForm.vue';
import FilledImage from './FilledImage.vue';
import LinksDownloadApps from './LinksDownloadApps.vue';
import WhatsappContact from './WhatsappContact.vue';

export default {
  name: 'SpecieDetails',
  components: {
    LinksDownloadApps,
    AudioPlay,
    Carousel,
    FilledImage,
    Loading,
    CustomModal,
    ClientValidationForm,
    WhatsappContact,
    LocationsMap,
    Youtube,
    SocialMedia,
  },
  data() {
    const currentEnv = process.env.VUE_APP_APP_ID ?? APP_IDS.Plants;
    return {
      specieId: this.$route.params.id,
      isLoading: true,
      isError: false,
      backgroundImage: '',
      screenshots: [],
      text: '',
      apiTextColor: '',
      defaultTextColor: '#253d2d',
      audio: false,
      autoplay: false,
      client: null,
      srcLogo: '',
      leftIcon: '',
      rightIcon: '',
      screenWidth: 0,
      whatsappText: '',
      whatsappNumber: '',
      mapUrl: '',
      mainLogoUrl: '',
      isPlantsEnv: currentEnv === APP_IDS.Plants,
      pdf: '',
      rightIconLink: '',
      leftIconLink: '',
      mainLogoLink: '',
      mapTitle: '',
      instagramTitle: '',
      youtubeTitle: '',
    };
  },
  async mounted() {
    this.isLoading = true;
    this.isError = false;
    const details = await this.getDetails(this.specieId);
    if (details) {
      this.backgroundImage = details.background;
      this.screenshots = this.getFormattedScreenshots(details.screenshots);
      this.text = details.text;
      this.apiTextColor = details.text_color;
      this.audio = details.audio;
      this.autoplay = false;
      this.client = details.client;
      this.srcLogo = details.logo;
      this.leftIcon = details.left_icon;
      this.rightIcon = details.right_icon;
      this.whatsappNumber = details.whatsapp_number;
      this.whatsappText = details.whatsapp_text;
      this.mapUrl = details.map_url;
      this.instagramUrl = details.instagram_url;
      this.youtubeUrl = details.youtube_url ?? '';
      this.audios = details.audios;
      this.pdf = details.pdfs[0]?.url ?? '';
      this.rightIconLink = details.right_icon_link ?? '#';
      this.leftIconLink = details.left_icon_link ?? '#';
      this.mainLogoLink = details.logo_link ?? '#';
      this.mapTitle = details.map_title;
      this.instagramTitle = details.instagram_title;
      this.youtubeTitle = details.youtube_title;
    } else {
      this.isError = true;
    }

    this.isLoading = false;
    this.onResize();

    window.addEventListener('resize', this.onResize);

    const faviconLink = document.createElement('link');
    faviconLink.rel = 'icon';
    faviconLink.type = 'image/png';
    faviconLink.href = this.isPlantsEnv
      ? this.favicons.pla.src
      : this.favicons.cvc.src;
    document.head.appendChild(faviconLink);
  },
  computed: {
    isViewedFromSmallScreen() {
      return this.screenWidth <= 768;
    },
    textColor() {
      return this.apiTextColor || this.defaultTextColor;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  created() {
    const appName = this.isPlantsEnv ? 'Plantsss' : 'Conoce Valora Conserva';
    document.title = `Ficha de Producto | ${appName}`;
    this.favicons = {
      cvc: new Image(),
      pla: new Image(),
    };

    this.favicons.cvc.src = '../favicon-cvc.png';
    this.favicons.pla.src = '../favicon-pla.png';
  },
  methods: {
    getAudioElement() {
      const audioId = this.isViewedFromSmallScreen
        ? 'audio-small-screens'
        : 'audio-big-screens';
      return document.getElementById(audioId);
    },
    onPlayEvent(audio) {
      const alreadyIdentified = localStorage.getItem('identifier');

      if (!this.client || alreadyIdentified) return;

      this.$bvModal.show('client-identifier');
      audio.pause();
    },
    playAudio() {
      const audio = this.getAudioElement();
      audio.play();
    },
    onValidationSuccess(success) {
      if (!success) return;

      this.$root.$emit('bv::hide::modal', 'client-identifier');
      this.playAudio();
    },
    onResize() {
      this.screenWidth = window.innerWidth;
    },
    getFormattedScreenshots(screenshots) {
      if (screenshots) return screenshots.map((image) => ({ src: image }));

      return [];
    },
    async getDetails(id) {
      const url = process.env.NODE_ENV === 'production'
        ? `${process.env.VUE_APP_API_SERVER}/api/v1/qr/${id}`
        : `/prod/api/v1/qr/${id}`;

      try {
        const { data: response } = await Axios.get(url);
        const { status, data = {} } = response;

        if (status !== 200) return false;

        return data;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comment-container {
  white-space: pre-line;
}
.message-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100vh;
}
.details-container {
  padding-top: 3rem;
  padding-bottom: 3rem;
  min-height: 100vh;
}

.logo-container {
  width: 100%;
  // min-height: 5rem;
}

.screenshot-container {
  width: 100%;
  overflow: hidden;
  margin-bottom: 3rem;
}

.text-plantss-color {
  color: #253d2d;
  --darkreader-inline-color: #253d2d !important;
}

.download-text {
  font-size: 1.4em;
  text-transform: uppercase;
  font-weight: 900;
}
</style>
